import { IKidsPotentielle, IKidsPotentielleSuche, IKidsTermin } from '../mgs.types';
import { formatDateIntl } from '@mng/mng-ts-helpers';

export const KIDS_TERMIN_BEARBEITUNGS_STATUS_ANGESCHRIEBEN = 10;
export const KIDS_TERMIN_BEARBEITUNGS_STATUS_NACH_SERIENDRUCK = 11;
export const KIDS_TERMIN_BEARBEITUNGS_STATUS_BEARBEITUNG = 12;
export const KIDS_TERMIN_BEARBEITUNGS_STATUS_ABGESCHLOSSEN = 13;

export const KIDS_TERMIN_TYP_08_30_ID = 30;
export const KIDS_TERMIN_TYP_09_15_ID = 31;
export const KIDS_TERMIN_TYP_10_00_ID = 32;

export const KIDS_TERMIN_STATUS_EINGELADEN = 20;
export const KIDS_TERMIN_STATUS_VORGEMERKT = 21;
export const KIDS_TERMIN_STATUS_FIX_ZUGESAGT = 22;
export const KIDS_TERMIN_STATUS_ENTSCHULDIGT = 23;
export const KIDS_TERMIN_STATUS_UNENTSCHULDIGT = 24;
export const KIDS_TERMIN_STATUS_ABGESAGT = 25;
export const KIDS_TERMIN_STATUS_TEILGENOMMEN = 26;

export const kidsTerminStatiZumSetzen = [
  KIDS_TERMIN_STATUS_TEILGENOMMEN,
  KIDS_TERMIN_STATUS_UNENTSCHULDIGT,
  KIDS_TERMIN_STATUS_ENTSCHULDIGT,
  KIDS_TERMIN_STATUS_FIX_ZUGESAGT
];

export function kidsTerminInfo(termin: IKidsTermin): string {
  if (!termin) {
    return '-';
  }
  // @ts-ignore
  const dateString = formatDateIntl(termin.date);

  return `${dateString}, ${termin.hotelBezeichnung} [${termin.terminTyp}]`;
}

export function kidsSucheParamsAsHtmlInfoText(
  suche: IKidsPotentielleSuche,
  terminResolver: (kidsTerminId: number) => IKidsTermin
) {
  let result = '';
  if (!suche) {
    result += 'Kein Filter Parameter definiert, Anzeige der Kinder sortiert nach <strong>Name</strong>';
  } else {
    const params = [];
    if (suche.name) {
      params.push(`Name beginnt mit <strong>${suche.name}</strong>`);
    }
    if (suche.vnName) {
      params.push(`VN Name beginnt mit <strong>${suche.vnName}</strong>`);
    }
    if (suche.kidsTerminId) {
      params.push(kidsTerminInfo(terminResolver(suche.kidsTerminId)));
    }

    if (suche.vertragsNr) {
      params.push(`Risiko Nr. beinhaltet <strong>${suche.vertragsNr}</strong>`);
    }

    if (suche.kidsAufWarteliste) {
      params.push(`Nur jene die auf einer Wartelist sind`);
    }

    result += params.join(', ');
  }

  return result;
}

export function isDruckAnforderungPassiert(kid: IKidsPotentielle): boolean {
  return !!kid.druckAbsageAnforderungDatum || !!kid.druckZusageAnforderungDatum;
}

export function isDruckZusagePassiert(kid: IKidsPotentielle): boolean {
  return !!kid.druckZusageAnforderungDatum;
}

export function isDruckAbsagePassiert(kid: IKidsPotentielle): boolean {
  return !!kid.druckAbsageAnforderungDatum;
}

export function isStatusAbgesagt(kid: IKidsPotentielle): boolean {
  return KIDS_TERMIN_STATUS_ABGESAGT === kid.terminStatus?.id;
}

export function isStatusTeilgenommen(kid: IKidsPotentielle): boolean {
  return KIDS_TERMIN_STATUS_TEILGENOMMEN === kid.terminStatus?.id;
}

export function isStatusFixZugesagt(kid: IKidsPotentielle): boolean {
  return KIDS_TERMIN_STATUS_FIX_ZUGESAGT === kid.terminStatus?.id;
}
